/* eslint-disable linebreak-style */
import {takeLatest, put, all, call} from 'redux-saga/effects';
import {
  SET_CURRENT_USER_START,
  SET_DELIVERY_ADDRESSES_START,
} from './user.actions.types'
import {setCurrentUserSuccess, setDeliveryAddressesSuccess} from './user.actions';
import {loadFirmeComisionarStart} from '../lookup/lookup.actions';
import {enqueueSnackbar, setLoading} from '../other/other.actions';
import {strapi} from '../../strapi/strapi.config';
import {setToken, adrese, setUser} from '../../strapi/strapi.utils';
import { push } from 'react-router-redux';


export function* getUser({payload:{email,password}}){
  try{
    console.log('Saga: Începe procesul de autentificare');
    yield put(setLoading(true));
    
    // Ștergem notificările existente
    yield put(enqueueSnackbar({
      message: '',
      options: {
        key: 'loading-message',
        variant: 'info',
        persist: false
      },
    }));
    
    console.log('Saga: Apel către API pentru autentificare');
    const response = yield strapi.login(email, password);
    console.log('Saga: Răspuns autentificare primit:', response?.user?.username);
    
    console.log('Saga: Salvare token');
    yield setToken(response);
    
    console.log('Saga: Salvare date utilizator');
    yield setUser(response.user);
    yield put(setCurrentUserSuccess(response.user));
    if (response?.user?.idFirma?.cfg1 === 'DA') {
      yield put(loadFirmeComisionarStart(response.user.idFirma.id));
    }

    // Login-ul trebuie să fie independent de nomenclatoare.
    yield put(push('/'));
    yield put(setLoading(false));

    // Încărcăm datele aplicației în fundal.
    yield put({ type: 'LOAD_FIRMA_START', payload: response?.user?.idFirma?.id });
    yield put({ type: 'LOAD_PRODUSE_START' });
    yield put({ type: 'LOAD_MATERIALE_START' });
    yield put({ type: 'LOAD_OPTIONALE_START' });
    yield put({ type: 'LOAD_CULORI_START' });
    yield put({ type: 'LOAD_INFORMARI_START' });
    yield put({ type: 'LOAD_PRETURITABELARE_START' });
    yield put({ type: 'LOAD_CURS_START' });
    yield put({ type: 'SET_DELIVERY_ADDRESSES_START', payload: response?.user?.idFirma?.id });
    
  } catch(error){ 
    console.error('Saga: EROARE la autentificare:', error);
    yield put(setLoading(false));
    yield put(enqueueSnackbar({
      message: `Datele introduse nu corespund unui utilizator valid.`,
      options: {
        key: null,
        variant: 'error',
        persist: false,
        autoHideDuration: 3000
      },
    }));
  }
}


 
export function* getDeliveryAddresses({payload:idFirma}){
  try{
    yield put(setLoading(true))
    const adreseLivrare= yield strapi.getEntries('adresalivrares',{idFirma})
    yield put(setDeliveryAddressesSuccess(adrese(adreseLivrare)))
    yield put(setLoading(false))
  }catch(error){ 
    yield put(setLoading(false))
    yield put(enqueueSnackbar({
      message: `Eroare : nu am putut prelua adresele de livrare ale firmei.(${error})`,
      options: {
        key: null,
        variant: 'error',
        persist:true,  
      },
    },5000))
  }
}



export function* onSetCurrentUserStart(){
  yield takeLatest (SET_CURRENT_USER_START,getUser)
}

export function* onSetDeliveryAddressesStart(){
  yield takeLatest (SET_DELIVERY_ADDRESSES_START,getDeliveryAddresses)
}




export function* userSagas(){
  yield all([
    call(onSetCurrentUserStart),
    call(onSetDeliveryAddressesStart),
  ])
}
